import React, { useEffect } from "react";
import BlogHeader from "./BlogPage/BlogHeader/BlogHeader";
import { useLocation } from "react-router-dom";
import { PathName } from "routers/types";

const PAGES_HIDE_HEADER_BORDER: PathName[] = [
  "/listing-car-detail",
  "/listing-experiences-detail",
  "/listing-stay-detail",
];

const SiteHeader = () => {
  const anchorRef = React.useRef<HTMLDivElement>(null);
  const [isTopOfPage, setIsTopOfPage] = React.useState(window.pageYOffset < 5);
  const location = useLocation();

  useEffect(() => {
    if (!PAGES_HIDE_HEADER_BORDER.includes(location.pathname as PathName)) return;

    const observer = new IntersectionObserver(
      (entries) => entries.forEach((e) => setIsTopOfPage(e.isIntersecting)),
      { root: null, rootMargin: "0px", threshold: 1.0 }
    );
    if (anchorRef.current) observer.observe(anchorRef.current);
    return () => observer.disconnect();
  }, [location.pathname]);

  const headerClassName = PAGES_HIDE_HEADER_BORDER.includes(location.pathname as PathName)
    ? isTopOfPage ? "" : "shadow-sm dark:border-b dark:border-neutral-700"
    : "shadow-sm dark:border-b dark:border-neutral-700";

  return (
    <>
      <BlogHeader className={headerClassName} />
      <div ref={anchorRef} className="h-1 absolute invisible" />
    </>
  );
};

export default SiteHeader;
